import { Skill } from '../creep-skill';

export const GENERATE_OPS: Skill = {
    name: 'generate_ops',
    desk: `Generate
    <span><b>1</b>/<b>2</b>/<b>4</b>/<b>6</b>/<b>8</b></span>
    ops resource units. Cooldown 50 ticks.`
} as Skill;

export const OPERATE_SPAWN: Skill = {
  name: 'operate_spawn',
  desk: `Reduce spawn time by
    <span><b>10%</b>/<b>30%</b>/<b>50%</b>/<b>65%</b>/<b>80%</b></span>.
    Effect duration 1000 ticks, cooldown 300 ticks. Range 3 squares. Consumes 100 ops resource units.`
} as Skill;

export const OPERATE_EXTENSION: Skill = {
  name: 'operate_extension',
  desk: `Instantly fill all extensions in the room using energy from the target structure (container, storage, or terminal).
    Max throughput <span><b>500</b>/<b>1000</b>/<b>1500</b>/<b>2000</b>/<b>2500</b></span> energy units.
    Range 3 squares. Cooldown 50 ticks. Consumes 2 ops resource units.`
} as Skill;

export const OPERATE_OBSERVER: Skill = {
  name: 'operate_observer',
  desk: `Grants unlimited range. Effect duration
    <span><b>100</b>/<b>200</b>/<b>300</b>/<b>400</b>/<b>500</b></span> ticks, cooldown 500 ticks.
    Range 3 squares. Consumes 10 ops resource units.`
} as Skill;

export const OPERATE_TOWER: Skill = {
  name: 'operate_tower',
  desk: `Increase damage, repair and heal amount by
    <span><b>10%</b>/<b>20%</b>/<b>30%</b>/<b>40%</b>/<b>50%</b></span>.
    Range 3 squares. Effect duration 100 ticks, cooldown 10 ticks. Consumes 10 ops resource units.`
} as Skill;

export const OPERATE_LAB: Skill = {
  name: 'operate_lab',
  desk: `Increase reaction amount by
    <span><b>2</b>/<b>4</b>/<b>6</b>/<b>8</b>/<b>10</b></span> units.
    Range 3 squares. Effect duration 1000 ticks, cooldown 50 ticks. Consumes 10 ops resource units.`
} as Skill;

export const OPERATE_TERMINAL: Skill = {
  name: 'operate_terminal',
  desk: `Decrease transfer energy cost and cooldown by
    <span><b>10%</b>/<b>20%</b>/<b>30%</b>/<b>40%</b>/<b>50%</b></span>.
    Range 3 squares. Effect duration 1000 ticks, cooldown 500 ticks. Consumes 100 ops resource units.`
} as Skill;

export const OPERATE_STORAGE: Skill = {
  name: 'operate_storage',
  desk: `Increase capacity by
    <span><b>500K</b>/<b>1000K</b>/<b>2000K</b>/<b>4000K</b>/<b>7000K</b></span> units.
    Range 3 squares. Effect duration 1000 ticks, cooldown is 800 ticks. Consumes 100 ops resource units.`
} as Skill;

export const REGEN_SOURCE: Skill = {
  name: 'regen_source',
  desk: `Regenerate <span><b>50</b>/<b>100</b>/<b>150</b>/<b>200</b>/<b>250</b></span> energy units
    in a source every 15 ticks. Duration 300 ticks. Range 3 squares. Cooldown 100 ticks.`,
  requiresLevel: [10, 11, 12, 14, 22]
} as Skill;

export const REGEN_MINERAL: Skill = {
  name: 'regen_mineral',
  desk: `Regenerate <span><b>2</b>/<b>4</b>/<b>6</b>/<b>8</b>/<b>10</b></span> mineral units in a deposit
    every 10 ticks. Duration 100 ticks. Range 3 squares. Cooldown 100 ticks.`,
  requiresLevel: [10, 11, 12, 14, 22]
} as Skill;

export const DISRUPT_SPAWN: Skill = {
  name: 'disrupt_spawn',
  desk: `Add <span><b>1</b>/<b>2</b>/<b>3</b>/<b>4</b>/<b>5</b></span> ticks to current spawning time.
    Cooldown 5 ticks. Range 20 squares. Consumes 10 ops resource units.`
} as Skill;

export const DISRUPT_TERMINAL: Skill = {
  name: 'disrupt_terminal',
  desk: `Block all incoming transactions. Effect duration 10 ticks, cooldown 8 ticks. Entire room range.
    Consumes <span><b>50</b>/<b>40</b>/<b>30</b>/<b>20</b>/<b>10</b></span> ops resource units.`,
  requiresLevel: [20, 21, 22, 23, 24]
} as Skill;

export const DISRUPT_TOWER: Skill = {
  name: 'disrupt_tower',
  desk: `Reduce effectiveness by
    <span><b>10%</b>/<b>20%</b>/<b>30%</b>/<b>40%</b>/<b>50%</b></span>.
    Effect duration 5 ticks. No cooldown. Entire room range. Consumes 10 ops resource unit.`
} as Skill;

export const DISRUPT_SOURCE: Skill = {
  name: 'disrupt_source',
  desk: `Increase regeneration time by
    <span><b>100</b>/<b>200</b>/<b>300</b>/<b>400</b>/<b>500</b></span> ticks.
    Range 3 squares. Cooldown 100 ticks. Consumes 100 ops resource units.`
} as Skill;

export const SHIELD: Skill = {
  name: 'shield',
  desk: `Create a temporary non-repairable rampart structure on the same square with
    <span><b>5K</b>/<b>10K</b>/<b>15K</b>/<b>20K</b>/<b>25K</b></span> hits. Cannot be used on top of
    another rampart. The structure lasts for 50 ticks and then disappears.
    Cooldown 20 ticks. Consumes 100 energy.`
} as Skill;


export const FORTIFY: Skill = {
    name: 'fortify',
    desk: `Make a wall or rampart tile invulnerable to all creep attacks and powers for
    <span><b>1</b>/<b>2</b>/<b>3</b>/<b>4</b>/<b>5</b></span> ticks. Cooldown 5 ticks. Range 3 squares.
    Consumes 5 ops.`
} as Skill;

export const OPERATE_CONTROLLER: Skill = {
    name: 'operate_controller',
    desk: `Increase max limit of energy that can be used for upgrading a Level 8 Controller each tick by
    <span><b>10</b>/<b>20</b>/<b>30</b>/<b>40</b>/<b>50</b></span> energy units. Cooldown 1000 ticks. Range 3 squares.
    Duration 800 ticks. Consumes 200 ops.`,
    requiresLevel: [20, 21, 22, 23, 24]
} as Skill;

export const OPERATE_POWER: Skill = {
    name: 'operate_power',
    desk: `Increase power processing speed of a Power Spawn by <span><b>1</b>/<b>2</b>/<b>3</b>/<b>4</b>/<b>5</b></span>
    units per tick. Cooldown 1000 ticks. Range 3 squares. Duration 800 ticks. Consumes 200 ops.`,
    requiresLevel: [10, 11, 12, 14, 22]
} as Skill;

// export const OPERATE_FACTORY: Skill = {
//     name: 'operate_factory',
//     desk: `This power has unknown effect.`
// } as Skill;


export const OPERATOR_SKILLS = [
  GENERATE_OPS,
  OPERATE_SPAWN,
  OPERATE_TOWER,
  OPERATE_STORAGE,
  OPERATE_LAB,
  OPERATE_EXTENSION,
  OPERATE_OBSERVER,
  OPERATE_TERMINAL,
  DISRUPT_SPAWN,
  DISRUPT_TOWER,
  DISRUPT_SOURCE,
  FORTIFY,
  SHIELD,
  OPERATE_POWER,
  REGEN_SOURCE,
  REGEN_MINERAL,
  OPERATE_CONTROLLER,
  DISRUPT_TERMINAL,
];



// WEBPACK FOOTER //
// /home/runner/work/power-planner/power-planner/src/app/skills/skills.operator.ts